import { useStoreActions } from 'stores/global';
import { TaskBarModalProps } from 'features/modalManager/types';

type DeferredModalContent = Pick<TaskBarModalProps, 'children' | 'contents'>;

// Store React nodes outside easy-peasy/Immer state to avoid deep-walking React element trees.
const deferredModalContentById = new Map<string, DeferredModalContent>();

export const getDeferredModalContent = (id: string): DeferredModalContent | undefined =>
  deferredModalContentById.get(id);

export const clearDeferredModalContent = (id: string): void => {
  deferredModalContentById.delete(id);
};

export const useDialog = () => {
  const { add, setActiveId } = useStoreActions(actions => actions.modalManager);

  const openDialog = (payload: TaskBarModalProps) => {
    return new Promise(resolve => {
      // check localstorage for show again
      if (payload.showAgainCheckbox) {
        const dontShowAgain = localStorage.getItem(`${payload.showAgainCheckbox}-showAgain`);
        if (dontShowAgain === 'true') {
          resolve('skip');
          return;
        }
      }

      // Avoid storing React nodes in global state (Immer can overflow the stack in prod builds).
      if (payload.children != null || payload.contents != null) {
        deferredModalContentById.set(payload.id, {
          children: payload.children,
          contents: payload.contents,
        });
      }

      add({ ...payload, children: undefined, contents: undefined, resolve, minimize: false });
      setActiveId(payload.id);
    });
  };

  return { openDialog };
};
